'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        width: { type: String, default: '238px' },
        readonly: { type: Boolean, default: false },
        value: { type: String, default: '' },
        format: { type: String, default: 'YYYY-MM-DD' },
        text: '',
        tabIndex: ''
    },
    data: function data() {
        return {
            show: false,
            days: TRANSLATIONS["input-header"]["datepicker"]["days"],
            months: TRANSLATIONS["input-header"]["datepicker"]["months"],
            date: [],
            inpvalue: '',
            now: new Date()
        };
    },

    watch: {
        now: function now() {
            this.update();
        },
        show: function show() {
            this.update();
        }
    },
    computed: {
        hasText: function hasText() {
            return this.inpvalue.length > 0;
        }
    },
    methods: {
        close: function close() {
            this.show = false;
        },
        update: function update() {
            var arr = [];
            var time = new Date(this.now);
            time.setMonth(time.getMonth(), 1); // the first day
            var curFirstDay = time.getDay() == 0 ? 6 : time.getDay() - 1;
            time.setDate(0); // the last day
            var lastDayCount = time.getDate();
            for (var i = curFirstDay; i > 0; i--) {
                arr.push({
                    text: lastDayCount - i + 1,
                    time: new Date(time.getFullYear(), time.getMonth(), lastDayCount - i),
                    status: 'date-pass'
                });
            }

            time.setMonth(time.getMonth() + 2, 0); // the last day of this month
            var curDayCount = time.getDate();
            time.setDate(1); // fix bug when month change
            var value = this.value || this.stringify(new Date());
            for (var _i = 0; _i < curDayCount; _i++) {
                var tmpTime = new Date(time.getFullYear(), time.getMonth(), _i + 1);
                var status = '';
                this.stringify(tmpTime) === value && (status = 'date-active');
                arr.push({
                    text: _i + 1,
                    time: tmpTime,
                    status: status
                });
            }

            var j = 1;
            while (arr.length < 42) {
                arr.push({
                    text: j,
                    time: new Date(time.getFullYear(), time.getMonth() + 1, j),
                    status: 'date-future'
                });
                j++;
            }
            this.date = arr;
        },
        yearClick: function yearClick(flag) {
            this.now.setFullYear(this.now.getFullYear() + flag);
            this.now = new Date(this.now);
        },
        monthClick: function monthClick(flag) {
            this.now.setMonth(this.now.getMonth() + flag);
            this.now = new Date(this.now);
        },
        pickDate: function pickDate(index) {
            this.show = false;
            this.now = new Date(this.date[index].time);
            this.value = this.stringify();
            this.$dispatch('pickdate', this.now);
        },
        parse: function parse(str) {
            var time = (0, _moment2.default)(str, this.format).toDate();
            return isNaN(time.getTime()) ? null : time;
        },
        stringify: function stringify() {
            var time = arguments.length <= 0 || arguments[0] === undefined ? this.now : arguments[0];
            var format = arguments.length <= 1 || arguments[1] === undefined ? this.format : arguments[1];

            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var date = time.getDate();
            var monthName = this.months[time.getMonth()];

            var map = {
                YYYY: year,
                MMM: monthName,
                MM: ('0' + month).slice(-2),
                M: month,
                DD: ('0' + date).slice(-2),
                D: date
            };
            return format.replace(/Y+|M+|D+/g, function (str) {
                return map[str];
            });
        },
        leave: function leave(e) {
            if (!this.$el.contains(e.target) || e.relatedTarget) {
                this.close();
            }
        }
    },
    ready: function ready() {
        this.now = this.parse(this.value) || new Date();
        document.addEventListener('click', this.leave, false);
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('click', this.leave, false);
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<div class=\"datetime-picker input-field\"><input type=text :style=styleObj readonly :value=value :placeholder=text :tabindex=tabIndex @focus=\"show = true\" @blur=leave id=\"{{ type }}\" class=\"{{ type }} {{ (hasText) ? 'has-text' : '' }}\" v-model=inpvalue><label for=\"{{ type }}\">{{ text }}</label><div class=picker-wrap v-show=show><table class=date-picker><thead><tr class=date-head><th colspan=4><span class=btn-prev @click=yearClick(-1)>&lt;</span> <span class=show-year>{{now.getFullYear()}}</span> <span class=btn-next @click=yearClick(1)>&gt;</span><th colspan=3><span class=btn-prev @click=monthClick(-1)>&lt;</span> <span class=show-month>{{months[now.getMonth()]}}</span> <span class=btn-next @click=monthClick(1)>&gt;</span><tr class=date-days><th v-for=\"day in days\">{{day}}<tbody><tr v-for=\"i in 6\"><td v-for=\"j in 7\" :class=\"date[i * 7 + j] &amp;&amp; date[i * 7 + j].status\" :date=\"date[i * 7 + j] &amp;&amp; date[i * 7 + j].date\" @click=\"pickDate(i * 7 + j)\">{{date[i * 7 + j] &amp;&amp; date[i * 7 + j].text}}</table></div></div>"
